import { useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { SubscriptionCheckoutQueryString } from "../../../../legacy/components/PaymentBackdrop/entities/subscription-checkout-query-string.enum";
import { useIsBackFromSubscriptionCheckout } from "../../../../legacy/components/PaymentBackdrop/hooks/use-is-back-from-subscription-checkout";
import { checkoutReturnIdAtom, consumedCheckoutIdAtom } from "../../store/checkout-return.store";

function CheckoutReturnListener(): null {
  const isBackFromCheckout = useIsBackFromSubscriptionCheckout();
  const [searchParams] = useSearchParams();
  const checkoutId = searchParams.get(SubscriptionCheckoutQueryString.ID);
  const consumedCheckoutId = useAtomValue(consumedCheckoutIdAtom);
  const setCheckoutReturnId = useSetAtom(checkoutReturnIdAtom);

  useEffect(
    function trackCheckoutReturn() {
      const isAlreadyConsumed = checkoutId === consumedCheckoutId;
      if (isBackFromCheckout && checkoutId && !isAlreadyConsumed) {
        setCheckoutReturnId(checkoutId);
      }
    },
    [isBackFromCheckout, checkoutId, consumedCheckoutId, setCheckoutReturnId]
  );

  useEffect(
    function resetOnRouteUnmount() {
      return function cleanup() {
        setCheckoutReturnId(null);
      };
    },
    [setCheckoutReturnId]
  );

  return null;
}

export default CheckoutReturnListener;
